class File {
  constructor(options = {}) {
    options = options || {}
    this.active = options.active || false
    this.base64encoded = options.base64encoded
    this.created = options.created
    this.fullpath = options.fullpath
    this.name = options.name
  }

  // Class methods
  static init(options) {
    if (options instanceof File) {
      return options
    }
    const instance = new File(options)
    return instance.isValid ? instance : null
  }
  static initFromArray(arr) {
    if (Array.isArray(arr)) {
      return arr.map(this.init)
    }
    return []
  }
  static initOnlyValidFromArray(arr = []) {
    return this.initFromArray(arr).filter((i) => i)
  }

  // getters
  get isValid() {
    return !!this.fullpath && !!this.name
  }

  get isUploaded() {
    return this.active
  }

}

export default {
  File
}
export {
  File
}
